// extracted by mini-css-extract-plugin
export var cardContainer = "_pz-0";
export var cardHeader = "_pz-2";
export var collapsedState = "_pz-3";
export var dragHandle = "_pz-5";
export var dragHandleIcon = "_pz-6";
export var dragging = "_pz-1";
export var titleArea = "_pz-4";